import React from 'react';
import Banner from "../../../components/pages/form/Banner/Banner";

const BannerPage = () => {
    return <Banner />
};

export default BannerPage;